import App from 'app/app.js';
import 'app/store/JobStore.js';
import 'app/store/VisualMerchandiseStore.js';

function LtAddOnDetailSummaryCtrl($scope, $timeout, JobStore, VisualMerchandiseStore) {
  this.init = function () {
    $timeout(function () {
      if ($scope.isScrollable) {
        $('#sticky').stickyfloat({
          duration: 0,
          offsetY: 0,
          parent: $('#auto-scroll')
        });
      }
    });
  };

  /**
   * Recursive method.
   * Will attempt to parse item names, will return item objects and/or if parse was successful
   *   must be in the format '(n) wxh description'
   *   examples:
   *     correct: '(1) 8x10', '(4) 3x7 Wallets', '(2) 5x7, (4) 3x7 Wallets'
   *     incorrect: '(4) Variety 3x7', '2-5x7 Individuals'
   * @param itemName - item name, ex. '(1) 8x10'
   * @param items - optionally pass previously parsed items
   * @returns itemName or parsed item string
   */
  this.parseItemName = function (itemName, items) {
    // \u00C0-\u00FF (Latin-1 Supplement) to cover French and Spanish
    var regex = /\((\d+)\)\s*(\d+)[xX](\d+)([\s\w\u00C0-\u00FF]*)/;

    try {
      if (regex.test(itemName)) {
        var result = regex.exec(itemName);
        var itemObj = {
          count: parseInt(result[1]),
          width: parseInt(result[2]),
          height: parseInt(result[3]),
          description: result[4]
        };

        var allItems = !items ? [itemObj] : items.concat(itemObj);
        return this.parseItemName(itemName.replace(regex, ''), allItems);
      } else {
        if (itemName.replace(',', '').trim().length !== 0) {
          return itemName;
        } else {
          return R.map(function (i) {
            return i.count + ' - ' + i.width + 'x' + i.height + (i.description ? ' ' + i.description : '');
          })(items).join(', ');
        }
      }
    } catch (e) {
      return itemName;
    }
  };

  this.saveToCart = function () {
    $scope.onSave();
  };

  this.hideDisclaimer = function () {
    return !JobStore.isPreOrder() && VisualMerchandiseStore.getVisualMerchandise().useSubjectImages;
  };
}

App.controller('LtAddOnDetailSummaryCtrl', [
  '$scope',
  '$timeout',
  'JobStore',
  'VisualMerchandiseStore',
  LtAddOnDetailSummaryCtrl
]);
